import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import CourseSummary from 'modules/react/signup/CourseSummary'
import SuccessSvg from 'modules/react/signup/SuccessSvg'

export default function SignupCompleted () {

  const { selectedCourseDate, getFormValue } = useContext(SignupContext)

  return (
    <>
      <LeftContent>
        <div className="title title--h3">Tak for din tilmelding</div>
        <div className="wysiwyg">Din tilmelding er nu sendt videre til dit jobcenter og/eller a-kasse. Du modtager din endelige bekræftelse på kurset direkte fra dem.
        </div>
        <div className="image-wrap image-wrap--center">
          {SuccessSvg()}
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary
          selectedCourseDate={selectedCourseDate}
          paymentType={getFormValue('sign_up_for_job') ? 'Jobcenter' : 'Egen betaling'}
        />
      </RightContent>
    </>
  )
}